import ConcluirComponent from './concluir.component'

export default ConcluirComponent
